var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarUniversities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.078,
    height: 13.836,
    viewBox: "0 0 15.078 13.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "graduation-cap",
    d: "M15.078,5.691v7.237a.628.628,0,1,1-1.257,0V7.747L9.173,9.968a3.141,3.141,0,0,1-1.619.436,3.312,3.312,0,0,1-1.7-.464L1.221,7.733a2.319,2.319,0,0,1-.053-4.055l.053-.028L5.906,1.414a3.283,3.283,0,0,1,3.318.028l4.633,2.207a2.367,2.367,0,0,1,1.221,2.042ZM7.553,11.66a4.561,4.561,0,0,1-2.29-.611L2.513,9.736v1.7a3.146,3.146,0,0,0,2.211,3,9.774,9.774,0,0,0,2.815.379,9.774,9.774,0,0,0,2.815-.381,3.146,3.146,0,0,0,2.211-3V9.74l-2.8,1.338a4.387,4.387,0,0,1-2.211.583Z",
    transform: "translate(0 -0.978)",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarUniversities);
export default __webpack_public_path__ + "static/media/sidebar-universities.d50155e671a5ab3a2832212143dbcb61.svg";
export { ForwardRef as ReactComponent };